import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import HistoryPage from './pages/HistoryPage';
import ForecastsPage from './pages/ForecastsPage';
import ProductForecastsPage from './pages/ProductForecastsPage';
import ProductSalesPage from './pages/ProductSalesPage';
import ProductStockPage from './pages/ProductStockPage';
import SeasonalPage from './pages/SeasonalPage';
import LoginPage from './pages/LoginPage';
import LeftoverProducts from './pages/LeftoverProducts';
import CronSettings from './pages/CronSettings';
import AIAgentPage from './pages/AIAgentPage';
import ErrorBoundary from './components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 60 * 1000, // 30 хвилин
      cacheTime: 30 * 60 * 1000, // 30 хвилин
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('authToken'));

  useEffect(() => {
    const listener = () => setIsAuthenticated(!!localStorage.getItem('authToken'));
    window.addEventListener('storage', listener);
    return () => window.removeEventListener('storage', listener);
  }, []);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Router>
          <InnerApp isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
        </Router>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

function PrivateRoute({ isAuthenticated, children }) {
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function InnerApp({ isAuthenticated, setIsAuthenticated }) {
  const location = useLocation();
  const showSidebar = isAuthenticated && location.pathname !== '/login';

  return (
    <div className="flex min-h-screen">
      {showSidebar && <Sidebar />}
      <main className="flex-grow p-6 bg-gray-50">
        <Routes>
          <Route path="/login" element={<LoginPage setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<PrivateRoute isAuthenticated={isAuthenticated}><Dashboard /></PrivateRoute>} />
          <Route path="/ai-agent" element={<PrivateRoute isAuthenticated={isAuthenticated}><AIAgentPage /></PrivateRoute>} />
          <Route path="/history" element={<PrivateRoute isAuthenticated={isAuthenticated}><HistoryPage /></PrivateRoute>} />
          <Route path="/forecasts" element={<PrivateRoute isAuthenticated={isAuthenticated}><ForecastsPage /></PrivateRoute>} />
          <Route path="/product-forecasts" element={<PrivateRoute isAuthenticated={isAuthenticated}><ProductForecastsPage /></PrivateRoute>} />
          <Route path="/product-sales" element={<PrivateRoute isAuthenticated={isAuthenticated}><ProductSalesPage /></PrivateRoute>} />
          <Route path="/product-stock" element={<PrivateRoute isAuthenticated={isAuthenticated}><ProductStockPage /></PrivateRoute>} />
          <Route path="/seasonal" element={<PrivateRoute isAuthenticated={isAuthenticated}><SeasonalPage /></PrivateRoute>} />
          <Route path="/leftovers" element={<PrivateRoute isAuthenticated={isAuthenticated}><LeftoverProducts /></PrivateRoute>} />
          <Route path="/cron" element={<PrivateRoute isAuthenticated={isAuthenticated}><CronSettings /></PrivateRoute>} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
